import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	automationHeader: {
		id: 'automation-menu.popup.run-rule.automation-header',
		defaultMessage: 'Automation',
		description: 'Label for the main header',
	},
});
